import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { ResultsBar } from '../ResultsBar/ResultsBar';
import styles from './DashboardHeader.module.css';
import { ExportCSVButton } from './ExportCSVButton/ExportCSVButton';
import { QuickFilters } from './QuickFilters/QuickFilters';
import { SearchBar } from './SearchBar/SearchBar';

export const DashboardHeader = () => {
  const { isContextError } = useIntroducerData();

  if (isContextError) {
    return null;
  }

  return (
    <header className={styles.header}>
      <div className={styles.topRow}>
        <div className={styles.leftSection}>
          <QuickFilters />
          <SearchBar />
        </div>

        <div className={styles.rightSection} id="export-csv">
          <ExportCSVButton />
        </div>
      </div>

      <ResultsBar />
    </header>
  );
};
